import type { PaywallCustomization } from "@circle-react/types/PaywallCustomization";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";
import type { UseCountdownOptions } from "./hooks/useCountdown";
import { useMaxWidthApplied } from "./hooks/useMaxWidthApplied";

interface CountdownComponentProps {
  countdownProperties: PaywallCustomization["countdown_properties"];
  useHook: (props: UseCountdownOptions) => { timeRemainingText: string };
}

export const CountdownComponent = ({
  countdownProperties,
  useHook,
}: CountdownComponentProps) => {
  const { timeRemainingText } = useHook({ countdownProperties });
  const { contentRef, maxWidth } = useMaxWidthApplied();

  return (
    <div className="border-primary bg-primary flex flex-row items-center justify-center gap-x-2 rounded-3xl border py-2.5">
      <Icon type="16-clock" viewBox="0 0 16 16" />
      <div className="flex flex-row items-center justify-center gap-x-1">
        <Typography.LabelSm weight="medium">
          {countdownProperties.displayed_text}
        </Typography.LabelSm>
        <div
          ref={contentRef}
          style={{ minWidth: maxWidth > 0 ? `${maxWidth}px` : "auto" }}
        >
          <Typography.LabelSm weight="semibold">
            {timeRemainingText}
          </Typography.LabelSm>
        </div>
      </div>
    </div>
  );
};
